import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./PersonTypeHelper.module.scss";

type Props = {
  options: Array<string>;
};

const PersonTypeHelper: React.FC<Props> = ({ options }) => {
  const [isActive, setActive] = useState(false);
  const classToggle = () => {
    setActive(!isActive);
  };
  function genDatalist() {
    const opts = options.map((val: string, i: number) => (
      <li value={val} key={i}>
        {val}
      </li>
    ));

    return opts;
  }

  return (
    <div className={styles["c-typelist"]}>
      <button onClick={classToggle}>
        <FontAwesomeIcon icon={["fal", "chevron-down"]} />
        タイプ一覧を見る
      </button>
      <ul className={isActive ? styles["active"] : null}>{genDatalist()}</ul>
    </div>
  );
};

export default PersonTypeHelper;
